// extracted by mini-css-extract-plugin
export default {"contact":"contact_contact__aXVnF","largeContact":"contact_largeContact__7XWPo","arkade":"contact_arkade__wGEIs","largeArkade":"contact_largeArkade__o870Z"};